
import { Socket } from 'socket.io-client';
import { formattedPhone } from '../helpers/PhoneHelper';
import { isNumber } from 'lodash';
import { ContactTypes } from './constants';


export type SelectMessagesOptions = {
    startDate : Date;
    messagesCount ?: number;
}

export type CrmUser = {
    email: string;
    phone: string;
    roles: string[];
    skills: string[];
    full_name: string;
    categories: number[];
    contact_uri: string;
    avg_call_value_scaled: number;
}

export type UserCredentials = {
    email: string | null;
    token: string | null;
    full_name: string | null;
    phone: string | null;
    departments?: number[] | null;
    sid: string;
    source?: CrmUser;
}

export type ContactsSubscribeCallback = (contacts: any) => void;

export type LogsItem = {
    eventName: string;
    payload?: any;
    info?: any;
}

export {
    Socket
};

export interface IBaseContact {
    phone: string;
}

export interface IContact extends IBaseContact {

    system_item_id: string;
    first_name: string;
    last_name: string;
    prime_member: boolean;
    avatar: string;
    phone: string;
    address: string;
    type: any;
    meta?: any;
}

export class Contact implements IContact {

    system_item_id;
    first_name;
    last_name;
    prime_member;
    avatar;
    phone: any;
    address;
    type: any;
    meta?: any;

    constructor(contactData: any) {

        this.system_item_id = contactData.system_item_id || contactData.id;
        this.first_name = contactData.first_name;
        this.last_name = contactData.last_name;
        this.avatar = contactData.avatar;
        this.prime_member = contactData.prime_member;
        this.phone = `+1${formattedPhone(contactData.phone)}`;
        this.address = contactData.address;
        this.type = isNumber(contactData.type) ? contactData.type : ContactTypes.TECHNICIAN;

        if (contactData.original && contactData.original.departments) {
            this.meta = {
                ...(contactData?.meta || {}),
                departments: contactData.original.departments
            };
        }
    }

}
